import { Media } from 'lib-shared-types-channels';
import { memo } from 'react';

import { mediaAttributes } from 'utils/channels/media';

import styles from './channelDashboardChannels.module.scss';
import { ChannelDashboardChannel } from './components/channel/channelDashboardChannel';

export const ChannelDashboardChannels = memo(
  function ChannelDashboardChannels(): JSX.Element {
    return (
      <div className={styles.cards}>
        {Object.entries(mediaAttributes).map(([media]) => (
          <ChannelDashboardChannel key={media} media={media as Media} />
        ))}
      </div>
    );
  },
);
